import { render } from "./StudentThoughtinfo.vue?vue&type=template&id=a1ab2576"
import script from "./StudentThoughtinfo.vue?vue&type=script&lang=js"
export * from "./StudentThoughtinfo.vue?vue&type=script&lang=js"

import "./StudentThoughtinfo.vue?vue&type=style&index=0&id=a1ab2576&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__